import React from 'react';

const UnreadIndicator = ({className, size, style}) => {
	return (
		<div className={`colour-bg-primary${className ? ' ' + className : ''}`} style={{...style, width: size ? size : 8, height: size ? size : 8, borderRadius: 100, flexShrink: 0}} />
   );
}

export default UnreadIndicator;